import { orangeColor2 } from "../../../styles/theme";
import { ToggleButton } from "../style";

interface ToggleButtonItemProps {
    selected: boolean;
    onClick: () => void;
    borderRadius: string;
    children: React.ReactNode;
}

const TOGGLE_ON_BG = 'rgba(255, 129, 22, 0.1)';
const TOGGLE_ON_COLOR = orangeColor2;

export function ToggleButtonItem({
    selected,
    onClick,
    borderRadius,
    children,
}: ToggleButtonItemProps) {
    return (
        <ToggleButton
            onClick={onClick}
            bgColor={selected ? TOGGLE_ON_BG : undefined}
            color={selected ? TOGGLE_ON_COLOR : undefined}
            fontWeight={selected ? '700' : undefined}
            borderRadius={borderRadius}
        >
            {children}
        </ToggleButton>
    );
}